import * as React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Stack, Typography, styled, css } from '@mui/material'
import Price from '../Price/Price'

const ProductPriceStyled = styled(Stack)(
  ({ theme }) => css`
    .strike-through-price {
      color: #07263b;
      margin: 0;
      font-size: 16px;
      line-height: 18.56px;
      font-weight: 400;

      &.highlight-strike-through-price {
        font-weight: 600;
      }
    }

    .regular-price {
      color: ${theme.palette.primary.dark};
      font-weight: 600;
      line-height: 18.56px;
      &.has-strike-through-price {
        color: ${theme.palette.secondary.dark};
      }
      &.highlight-price {
        color: ${theme.palette.error.main};
      }
    }
  `,
)

const ProductPrice = ({
  dataTestId,
  fontSize,
  highlightPrice = false,
  price,
  sale = false,
  strikeThrough = false,
  strikeThroughPrice = 0,
}) => (
  <ProductPriceStyled direction="row" alignItems="center" spacing={1} marginBottom="8px">
    {strikeThrough && (
      <Typography
        className={classNames('strike-through-price', { 'highlight-strike-through-price': highlightPrice })}
        fontSize={fontSize || '16px'}
        data-testid={!dataTestId ? null : `${dataTestId}-strikethrough`}
      >
        <Price price={strikeThroughPrice} strikeThrough />
      </Typography>
    )}
    <Typography
      noWrap
      className={classNames('regular-price', {
        'has-strike-through-price': strikeThrough,
        'highlight-price': highlightPrice || sale,
      })}
      fontSize={fontSize}
      data-testid={dataTestId ?? null}
    >
      <Price price={price} />
    </Typography>
  </ProductPriceStyled>
)

ProductPrice.propTypes = {
  dataTestId: PropTypes.string,
  fontSize: PropTypes.string,
  highlightPrice: PropTypes.bool,
  price: PropTypes.number.isRequired,
  strikeThrough: PropTypes.bool,
  strikeThroughPrice: PropTypes.number,
  sale: PropTypes.bool,
}

export default ProductPrice
